import React from "react";

import { MarketplaceButton, MarketplaceButtonProps } from "./marketplace_button";

type TertiaryButtonProps = Omit<MarketplaceButtonProps, "theme">;

export const MarketplaceTertiaryButton = ({
  children,
  ...props
}: React.PropsWithChildren<TertiaryButtonProps>) => (
  <MarketplaceButton {...props} kind="tertiary" theme="tertiary">
    {children!}
  </MarketplaceButton>
);
